var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSenseNewLogo = function SvgSenseNewLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD252",
    d: "M7.569 12.435c1.418 0 2.568-1.168 2.568-2.609 0-1.44-1.15-2.609-2.568-2.609S5 8.385 5 9.827c0 1.44 1.15 2.608 2.569 2.608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F05A28",
    d: "M15.274 7.217c1.419 0 2.569-1.168 2.569-2.608S16.693 2 15.274 2c-1.418 0-2.568 1.168-2.568 2.609 0 1.44 1.15 2.608 2.568 2.608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7461E5",
    d: "M7.569 22c1.418 0 2.568-1.168 2.568-2.609 0-1.44-1.15-2.608-2.568-2.608S5 17.95 5 19.39 6.15 22 7.569 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33A30F",
    d: "M15.274 16.783c1.419 0 2.569-1.168 2.569-2.61 0-1.44-1.15-2.608-2.569-2.608-1.418 0-2.568 1.168-2.568 2.609 0 1.44 1.15 2.609 2.568 2.609"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 2h13v20H5z"
  })))));
};
export default SvgSenseNewLogo;